import { GatsbyBrowser } from "gatsby";
import "./src/styles/global.css";

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = () => {
  // Ensure custom.js runs on every page navigation
  if (typeof document !== "undefined") {
    const existing = document.getElementById("custom-js");
    if (existing) {
      existing.remove();
    }
    const script = document.createElement("script");
    script.id = "custom-js";
    script.src = "/js/custom.js";
    script.async = true;
    document.body.appendChild(script);
  }
};

